
const LOGO_URL = 'https://static.readdy.ai/image/d21c811a591cac7dc9306c593ec79059/f7e5252675c8f97538d8efad23113515.png';

export default function Footer() {
  return (
    <footer className="bg-[#f5f7fa] py-10">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center gap-4">
        <div className="w-44 h-14 flex items-center justify-center">
          <img
            src={LOGO_URL}
            alt="Sunshine Air Pros logo"
            title="Sunshine Air Pros air duct cleaning dryer vent cleaning"
            className="w-full h-full object-contain"
          />
        </div>
        <p className="text-xs text-gray-500 text-center">
          &copy; {new Date().getFullYear()} Sunshine Air Pros. All rights reserved.
        </p>
        <p className="text-xs text-gray-400">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="hover:text-[#1E88E5] transition-colors"
          >
            Powered by Readdy
          </a>
        </p>
      </div>
    </footer>
  );
}
